<template>
  <div class="flex items-center gap-2">
    <div class="w-full pt-2">
      <div class="relative">
        <label class="label-primary" :for="id">
          <span v-if="isChangeCase">{{ changeCase(label, ElementE.LABEL) }}</span>
          <span v-else>{{ label }}</span>
        </label>
        <input
          :id="id"
          :value="backColor"
          type="text"
          class="input-primary"
          :placeholder="(changeCase('choose colour', ElementE.PLACEHOLDER) as string)"
          @change="saveInput"
        />
      </div>
    </div>

    <div
      class="mt-2 flex-shrink-0 self-stretch flex justify-center items-center w-12 h-auto bg-white"
    >
      <div class="relative w-11 h-11 overflow-hidden cursor-pointer rounded-lg border border-gray-300">
        <input
          :id="id + 'ccc'"
          :parentId="id"
          type="color"
          :value="val"
          class="absolute -top-2.5 -left-2.5 w-16 h-16 cursor-pointer"
          @input="pickColor"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import {HtmlEvent} from "@/interfaces/interfaces";
import { changeCase } from "../helpers";
import { ElementE } from '../enums';

export default defineComponent({
  name: "SelectColor",
  props: {
    id: { type: String, required: true, default: "" },
    label: { type: String, required: true, default: "" },
    value: { type: String, required: true, default: "#ffffff" },
    isChangeCase: { type: Boolean, default: true },
  },
  mounted() {
    this.val = this.value;
  },
  watch: {
    value: function (nvalue) {
      this.val = nvalue
      this.backColor = nvalue;
    }
  },
  methods: {
    saveInput(e: HtmlEvent){
      this.$emit("colors", {
        id: e.target.id,
        color: e.target.value
      });
    }
  },
  data(){
    return {
      val: '#ffffff',

      changeCase: changeCase,
      ElementE: ElementE,
    }
  },
  emits: ["colors"],

  setup(props, { emit }) {
    const backColor = ref<string>(props.value || "");

    const pickColor = (e: Event) => {
      backColor.value = (e.target as HTMLInputElement).value;
      let parentId = (e.target as HTMLInputElement).getAttribute('parentId');

      emit("colors", {
        id: parentId,
        color: backColor.value
      });
    };

    return { backColor, pickColor };
  },
});
</script>
